<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogConstat" :persistent="true"  width="80%" transition="dialog-bottom-transition" scrollable
                  >
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title v-if="!validConstat">Effectuer le constat pour la demande de maintenance DMD-{{demandeDetail.ref}}</v-toolbar-title>
                     <v-toolbar-title v-else >Valider le constat pour la demande de maintenance DMD-{{demandeDetail.ref}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12  >
                            <v-alert v-if="!validConstat" :value="true" outline color="purple" icon="info" class="mb-4" >
                                Telecharger des images pour le constat
                            </v-alert>
                            <v-alert v-else :value="true" outline color="purple" icon="info" class="mb-4" >
                                Rapport effectue
                            </v-alert>
                        </v-flex>

                        <v-flex xs12  >
                            <el-form :disabled="validConstat" id="formRapport1" style="width:100%" ref="formRapport1"   :model="formRapport"  >
                                <v-layout row >
                                    <v-flex xs8 >
                                        <v-layout row>
                                            <v-flex v-show="!validConstat" xs2 class="mr-2" >  
                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                                <v-layout row>
                                                    <input name="image1" type="file" style="display:none" ref="file1" accept="image/*" @change="onFileImage1Picked"/>
                                                    <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                                    <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div>
                                                </v-layout>
                                            </v-flex>
                                             <v-flex v-show="validConstat"  xs3 class="mr-3">
                                            <a :href="demandeDetail.imageConst1"  target=_blank>
                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageConst1" ></v-avatar>
                                            </a>
                                        </v-flex>
                                        </v-layout>    
                                     </v-flex>

                                 <v-flex xs4 >
                                         <el-form-item style="width:100%" label="Rapport de constat" >
                                        <el-input
                                        style="width:100%"
                                           :disabled="validConstat"
                                            type="textarea"
                                            :rows="6"
                                            placeholder="Rapport sur le constat"
                                            v-model="formRapport.rapport">
                                        </el-input>
                                         </el-form-item >
                                </v-flex>
                            </v-layout>
                            </el-form>
                             </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                            <v-card>
                                <v-flex xs12 class="mb-2">
                                    <v-alert :value="true" outline color="purple" icon="info">
                                        Besoins materiels
                                    </v-alert>
                                    </v-flex>
                                        <el-form :disabled="validConstat" id="formProduit" :rules="ruleFormProduit" ref="refFormProduit"  label-position="top" :inline="true" :model="formProduit" class="demo-form-inline">
                                            <v-layout row v-show="!validConstat">
                                                <v-flex md3>
                                                     <el-form-item label="Designation"   prop="designation" >
                                                         <el-select  :disabled="validConstat" filterable @change="handleChangePrix()"  style="width:100%" v-model="formProduit.idProd" placeholder="Select">
                                                            <el-option
                                                                    v-for="item in listeProduit"
                                                                    :key="item.id"
                                                                    :label="item.libelle"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </v-flex>
                                                    <v-flex md3>
                                                        <el-form-item label="Quantite"  prop="quantite">
                                                            <el-input-number  :disabled="validConstat" :min="1" size="large" controls-position="right"   v-model="formProduit.quantite" placeholder="quantite" ></el-input-number>
                                                        </el-form-item>
                                                    </v-flex>
                                                     <v-flex md3  v-show=false>
                                                         <el-form-item label="Prix Unitaire(FCFA)" prop="prixU">
                                                            <el-input-number  :min="0" disabled size="large" controls-position="right"    v-model="formProduit.prixUnit" placeholder="prix unitaire(HT)"  style="width:100%"></el-input-number>
                                                        </el-form-item>
                                                    </v-flex>
                                                    <v-flex md3>
                                                         <el-form-item label="Unite" prop="unite">
                                                            <el-input  size="large" disabled value="pcs"    v-model="formProduit.unite" placeholder=""  style="width:100%"></el-input>
                                                        </el-form-item>
                                                    </v-flex>
                                                      <v-flex md3>
                                                           <el-form-item label="    " >
                                                            <el-button  :disabled="validConstat" type="primary" @click="addListProduit('refFormProduit',formProduit)">Ajouter</el-button>
                                                            </el-form-item>
                                                    </v-flex>
                                                    
                                                </v-layout>

                                            </el-form>

                                             <v-spacer></v-spacer>
                                                <v-chip v-show="false" style="font-size:20px" label outline color="green"><b>Total (TTC): {{totalTTC}} fcfa</b></v-chip>
                                            <br>

                                            <v-layout row>
                                                <el-table :data="tableProduit" style="width: 100%" :disabled="validConstat">
                                                    <el-table-column prop="designation" label="Designation" sortable> </el-table-column>
                                                    <el-table-column prop="quantite" label="Quantite"> </el-table-column>
                                                    <!-- <el-table-column   prop="prixU" label="Prix Unitaire(FCFA)"></el-table-column> -->
                                                    <el-table-column prop="unite" label="unite"> </el-table-column>
                                                    <!-- <el-table-column v-show="false" prop="mntTotal" label="Total(Fcfa)"> </el-table-column> -->
                                                    <el-table-column  v-if="!validConstat" label="Operations">
                                                        <template slot-scope="scope">
                                                            <v-tooltip top>
                                                                <v-btn  :disabled="validConstat" slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableProduit)" dark>
                                                                    <v-icon center>delete</v-icon>
                                                                </v-btn>
                                                                Supprimer ce produit
                                                            </v-tooltip>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </v-layout>
                                            <br>
                                        </v-card>

                        </v-flex>

                        <!-- bouton validation -->
                        </v-layout>   

                        <v-layout row  class="text-xs-right" >
                             <v-flex xs12 class="text-xs-right" v-if="!validConstat"  >
                                <v-btn icons dark color="green" @click="submitForm()">Enregistrer<v-icon right>add</v-icon></v-btn>
                             </v-flex> 
                             
                             <v-flex xs12 class="text-xs-right" v-if="this.demandeDetail.etatDmd == 4"  >
                                <v-btn icons dark color="green" @click="dialogConfirm = true">Confirmer de la Validation<v-icon right>add</v-icon></v-btn>
                             </v-flex> 
                        </v-layout>

                        <v-layout class="text-xs-right"  v-if="this.demandeDetail.etatDmd == 3">
                            <v-flex xs12  >
                                <v-btn icons dark color="red" @click="dialogConfirmRefus = true">Refuser<v-icon right>add</v-icon></v-btn>
                                <v-btn icons dark color="green" @click="dialogConfirm = true">Valider<v-icon right>add</v-icon></v-btn>
                             </v-flex>    
                        </v-layout>

                         
                         <!-- bouton validation -->                  
                        
                    
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Validation du devis pour une demande de maintenance</v-card-title>
                <v-card-text>Voulez vous valider le devis ?</v-card-text>
                <v-flex xs12 class="mb-2 ml-1 mr-1">
                     <el-alert v-if="demandeDetail.entrepot == null"
                        title="Aucun entrepot défini dans la zone "  
                        :description="'Pour générer un bon de sortie vous devez définir un entrepot pour la zone '+demandeDetail.libZone"
                        :closable="false"
                        show-icon
                        type="warning">
                    </el-alert>
                </v-flex>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="dialogConfirm = false">Annuler</v-btn>
                <v-btn color="green darken-1" flat @click.native="SubmitValideDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>



          <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Validation du devis pour une demande de maintenance</v-card-title>
                <v-card-text>
                    <el-form :disabled="validConstat" id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                     <v-flex xs12 >
                        <el-form-item style="width:100%" label="Voulez vous Refuser ce devis ?" prop="rapportRefus" >
                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                        </el-form-item >
                    </v-flex>
                    </el-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                <v-btn color="green darken-1" flat @click.native="SubmitRefusDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
          <!-- RACOURCIS -->
    
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "ConstatMaintenance",
         props: {
             show:{
                 type: Boolean
             } ,
             demandeDetail: {
                 type: Object
             },
             validConstat: {
                 type: Boolean,
                 default: false
             }
         },
        data() 
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            listeProduit: [],
            formRapport: {
                rapport: ""
            },
            formRefus:{},

            rapport:"",
            dialogConstat: false,
            dialogConfirm: false,
            dialogConfirmRefus:false,
            tableProduit: [],
            totalTTC: 0,
            fileList: [],
             dialogImageUrl: '',
             formProduit: {},
            dialogVisible: false,
            //image
            image1: "/static/img-doc.png", 
            image2: "/static/img-doc.png", 
            image3: "/static/img-doc.png", 
            image4: "/static/img-doc.png", 
            file1: "",
            file2: "",
            file3: "",
            ruleFormProduit: {
                idProd: [
                    { required: true, message: 'Veuillez saisir' }, 
                ],
                quantite: [
                    { required: true, message: 'Veuillez saisir' }, 
                ],  
            },
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' }, 
                ],
            }
         }    
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogConstat= newValue
            },
            validConstat:  function(newValue, oldvalue){
               if(newValue == true){
                   //charger les donnees 
                   console.log("demande")
                   console.log(this.demandeDetail)
                   this.formProduit = {};
                   this.loadDevisConstat()
                   this.loadProduit()
               } 
            }
        },

        methods: {

            onFileImage1Picked(event) 
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) 
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file1 = files[0]
            },
         //enregistrement des images
        onFileImage2Picked(event) 
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) 
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image2 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file2 = files[0]
            },

         //enregistrement des images
        onFileImage3Picked(event) 
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) 
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image3 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file3 = files[0]
            },
             
             handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleSuccess(response, file, fileList){
                 console.log("succeess");
                  console.log(response, file, fileList);
                    this.fileList.push(file)

            },
            handlePictureCardPreview(file, fileList) {
                 console.log(file, fileList);
                this.dialogImageUrl = file.url;
               
                this.dialogVisible = true;
            },
             closeDialog(){
                
                this.$emit('close')
            },
            addListProduit(formName,item){
                this.$refs[formName].validate((valid) => {
                    if (valid) 
                    {
                        this.tableProduit.push({
                        designation : item.designation,
                        quantite : item.quantite,
                        unite: item.unite,
                        prixU : item.prixUnit,
                        mntTotal: parseInt(item.quantite) * parseInt(item.prixUnit)
                        })
                        this.totalTTC += parseInt(item.quantite) * parseInt(item.prixUnit)
                        // reinitilisation des champs
                        this.formProduit.prixUnit = 5
                        this.formProduit.unite = ""
                        this.resetForm(formName)
                    }
                })
            },

             deleteRow(index, rows) {
                 let item = rows.splice(index, 1);
                 console.log("item spp")
                 console.log(item)
              
                this.totalTTC -= parseInt(item[0].mntTotal)
            },
            
            submitForm(){
                
                this.loading = true
                 let url = this.domaine + 'demande_maintenance/save/constat'
                let form = document.getElementById('formRapport1')
                let data = new FormData(form)
                data.append("tableProduit",  JSON.stringify(this.tableProduit)) 
                data.append("rapport",this.formRapport.rapport)
                data.append("idUser",this.user.id)
                data.append("idDemande",this.demandeDetail.idDemande)
                //data.append("file",this.fileList,Blob)
                 this.$http.post(url, data).then(response => {
                     this.resetChampsConstat()
                      //reinitialisation des images telecharger
                      this.image1 = "/static/img-doc.png";
                      this.image2 = "/static/img-doc.png"; 
                      this.image3 = "/static/img-doc.png"; 
                      this.image = "/static/img-doc.png"; 
                      this.file1 = "";
                      this.file2 = "";
                      this.file3 = "";
                     this.closeDialog()
                     this.loading = false
                        if(response.body.code == 5){
                            this.successNotif(response.body.message,"error")
                        }else{
                            this.successNotif(response.body.message)
                        }                
                  },(erreurRep) => {
                    this.$message.error("Une erreur est survenue lors de l'enregistrement du constat")
                })
            },
            loadProduit (){
            let url = this.domaine + 'product/load-product-stock'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listeProduit = response.body
                }
            })
            },
            loadDevisConstat ()
            {
            this.loading = true
            let url = this.domaine + 'demande_maintenance/devis/constat/'+this.demandeDetail.idDemande
            this.$http.get(url).then(response => {
               
                console.log("table produit")
                console.log(response.body)
                this.tableProduit = response.body.tableProduit
                this.formRapport.rapport = response.body.rapport
                this.totalTTC = response.body.total
                 this.loading = false
            },errResp=>{
                 this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
            })
            },

             handleChangePrix() {
             console.log("option")
             console.log(this.formProduit.idProd)
             this.loading = true;
             console.log(this.formProduit)
            let url = this.domaine +  'demande_maintenance/recherche/produit/'+this.formProduit.idProd
            this.$http.get(url).then(response => {
                    this.loading =  false

                    
                    let produit = response.body.produit
                    console.log("produit selectionner")
                    console.log(produit)

                    this.formProduit.prixUnit  =  produit.valeur
                    this.formProduit.unite = produit.unite
                     this.formProduit.designation = produit.designation

                    // if(produit.valeur <= 0) {
                    //     this.$message({
                    //     message: 'Les prix de vente produits doivent être supérieur à zéro pour établir un devis correcte',
                    //     type: 'warning',
                    //     duration: 10000
                    // });
                    // }

                    if( this.formProduit.unite == null){
                        this.formProduit.unite = "pcs";
                    }
                    
                
            }, errReponse => {
                this.loading =  false
                 this.$message.error("Une erreur est survenue lors du produit")
            })
        },

        resetForm(formName) 
        {
          console.log("resetForm")
          this.$refs[formName].resetFields();
        },
        
         successNotif(mess = "Constat enregistrée avec succès",type = "success"){
            this.$notify({
                    title: 'ENREGISTREMENT CONSTAT',
                    message: mess,
                    type: type,
                    position: 'top-center',
                    duration: 15000
            })
        },

        resetChampsConstat()
        {
                 this.tableProduit.splice(0);
                 this.totalTTC = 0;
                 this.formRapport.rapport = ""
            },
            SubmitValideDevis(){
                this.loading = true
                  let url = ""
                if(this.demandeDetail.etatDmd == 4){
                    url = this.domaine + 'demande_maintenance/devis/validation2'
                }else {
                     url = this.domaine + 'demande_maintenance/devis/validation1'
                }
                
                let data = new FormData()
                data.append("idDemande",  this.demandeDetail.idDemande) 
                data.append("idUser",  this.user.id) 
                this.$http.post(url,data).then(response => {
                this.loading = false
                 if(response.body.code == 5){
                      this.successNotif(response.body.message,"error")
                  }else{
                      this.successNotif(response.body.message)
                  }
                 this.dialogConfirm = false
                  this.closeDialog();
                
               
            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors de la validation du devis")
            })
            },

             SubmitRefusDevis(){
                //this.loading = true
                let url = this.domaine + 'demande_maintenance/devis/refuser'
                let data = new FormData()
                data.append("idDemande",  this.demandeDetail.idDemande)  
                data.append("idUser",  this.user.id) 
                data.append("rapport",  this.formRefus.rapport) 
               
                this.$http.post(url,data).then(response => {
                this.loading = false
                if(response.body.code == 5){
                      this.successNotif(response.body.message,"error")
                  }else{
                      this.successNotif(response.body.message)
                  }
                 this.dialogConfirmRefus = false
                this.closeDialog();
            
            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors du refus du devis")
            })
            }

        },
    
        mounted(){
             this.loadProduit()
        }

    }
    </script>


// WEBPACK FOOTER //
// src/components/maintenance/ConstatMaintenance.vue